import { createFileRoute } from '@tanstack/react-router';
import { useMemo } from 'react';
import { LabsPublishedList, LabsReviewProvider, LabsReviewQueue, type LabsReviewModule } from '@ludolio/shared-labs';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@ludolio/shared-ui';
import { labsReviewApi } from '@/services/api';

function getErrorMessage(error: unknown): string {
  const message = (error as { response?: { data?: { message?: unknown } } })?.response?.data?.message;
  return typeof message === 'string' ? message : 'Something went wrong. Please try again.';
}

export const Route = createFileRoute('/_authenticated/labs')({
  component: LabsPage,
});

function LabsPage() {
  const reviewModule = useMemo<LabsReviewModule>(() => ({ api: labsReviewApi, getErrorMessage }), []);

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Ludolio Labs</h1>
      <LabsReviewProvider module={reviewModule}>
        <Tabs defaultValue="review">
          <TabsList>
            <TabsTrigger value="review">Review</TabsTrigger>
            <TabsTrigger value="published">Published</TabsTrigger>
          </TabsList>
          <TabsContent value="review" className="mt-6">
            <LabsReviewQueue scope="units" emptyMessage="No projects from your units are waiting for review" />
          </TabsContent>
          <TabsContent value="published" className="mt-6">
            <LabsPublishedList scope="units" emptyMessage="No projects from your units are published" />
          </TabsContent>
        </Tabs>
      </LabsReviewProvider>
    </div>
  );
}
